import type { StudyReportVersion } from '../../../types/studyTimeline';
import ReportVersionRow from './ReportVersionRow';
import styles from './ReportHistorySubRail.module.css';

interface ReportHistorySubRailProps {
  expanded: boolean;
  versions: StudyReportVersion[];
  onOpenVersion: (uuid: string) => void;
}

export default function ReportHistorySubRail({
  expanded,
  versions,
  onOpenVersion,
}: ReportHistorySubRailProps) {
  if (versions.length === 0) return null;

  return (
    <div className={styles.rail} data-expanded={expanded}>
      <div className={styles.railInner}>
        {versions.map((v) => (
          <ReportVersionRow key={v.uuid} version={v} onOpen={onOpenVersion} />
        ))}
      </div>
    </div>
  );
}
